<template>
  <div>
      <img :src="banner"/>
  </div>
</template>

<script>
import banner from '@/assets/banner/banner.jpg'
import bannerEn from '@/assets/banner/bannerEn.jpg'
import bannerTw from '@/assets/banner/bannerTw.png'
export default {
  data() {
    return {
      banner,
      bannerEn,
      bannerTw
    }
  }
}
</script>

<style scoped>
  img {
    width: 100rem;
  }
</style>


// WEBPACK FOOTER //
// src/components/Banner.vue